export default __webpack_public_path__ + "images/0xe4eeb461ad1e4ef8b8ef71a33694ccd84af051c4.png";